import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import ProductForm from './ProductForm';

const EditProductDialog = ({ open, onClose, product, categories, refetch }) => {
  const [currentProduct, setCurrentProduct] = useState(null);

  useEffect(() => {
    if (product) {
      setCurrentProduct({ ...product });
    }
    else{
        setCurrentProduct({category: '',
        name: '',
        image: null,
        imagePreview: null,
        whatsapp: '',
        share: '',
        description: '',
        origPrice: '',
        price: '',
        priority:1,
        active: true
      })
    }
  }, [product]);

//   if (!currentProduct) return null;

  return (
    <Dialog open={open} onClose={onClose}  fullWidth>
      <DialogTitle>{currentProduct&&currentProduct.id?'Edit Product':'Add Product'}</DialogTitle>
      <DialogContent style={{width:'100%'}} dividers>
            <ProductForm
  product={currentProduct}
          setProduct={setCurrentProduct}
          categories={categories}
  refetch={refetch}
  onSuccess={onClose}
/>
      </DialogContent>
    
    </Dialog>
  );
};

export default EditProductDialog;
